import { useAlert } from '@common/hooks';
import { Copy } from '@geist-ui/icons';
import { Tooltip, UnstyledButton } from '@mantine/core';
import { FC, Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setTooltipTimeout } from 'src/helpers/setTooltipTimeout';

import styles from './styles.module.scss';

interface SiteLinkProps {
  website: string | undefined;
}

const SiteLink: FC<SiteLinkProps> = ({ website }) => {
  const [opened, setOpened] = useState(false);
  const { showAlert } = useAlert();
  const [c] = useTranslation('automatedReports');
  const [t] = useTranslation('common');

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (opened) {
      setTooltipTimeout(2000).then(() => {
        setOpened(false);
      });
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [opened]);

  const handleCopyClick = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(website || '');
      setOpened(true);
    } catch (err) {
      showAlert({
        id: 'copy-error',
        title: t('errorTitle'),
        message: `${c('failedToCopy')}`,
        variant: 'error',
      });
    }
  };
  return (
    <Fragment>
      {website && (
        <div className={styles.siteLink}>
          <Tooltip label={`${c('linkCopied')}`} opened={opened} withArrow>
            <UnstyledButton onClick={handleCopyClick}>
              <Copy color={'#5b5eff'} size={20} aria-label="copy icon" />
            </UnstyledButton>
          </Tooltip>
          <a
            className={styles.link}
            target={'_blank'}
            href={website}
            rel="noreferrer"
            aria-label={`${t('opensInNewTab')}`}>
            {website}
          </a>
        </div>
      )}
    </Fragment>
  );
};

export default SiteLink;
